/**
 * Identificação do cliente no agendamento público: CPF ou e-mail no mesmo campo.
 *
 * Clientes importados de outros aplicativos chegam quase sempre sem CPF, então o portal
 * aceita os dois. A decisão de qual é qual acontece enquanto o cliente digita, e por isso
 * não pode depender do "@": ele é um dos últimos caracteres a aparecer. Enquanto o valor
 * tiver só dígitos e a pontuação do CPF, vale a máscara do documento; a primeira letra
 * digitada já muda o campo para e-mail.
 */

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Dígitos e a pontuação que a máscara de CPF insere. */
const DOCUMENT_CHARS = /^[\d.\s-]*$/;

/**
 * O valor ainda pode virar um CPF?
 *
 * Campo vazio conta como documento: o placeholder e o teclado numérico abrem no caso mais
 * comum, e mudam sozinhos assim que o cliente digita uma letra.
 */
export const looksLikeDocument = (value) => DOCUMENT_CHARS.test(value || '');

/** O valor é um e-mail, e não um CPF. */
export const isEmailIdentifier = (value) => !looksLikeDocument(value);

export const formatCpf = (value) => {
    const digits = (value || '').replace(/\D/g, '').slice(0, 11);
    return digits
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

/** Aplica a máscara de CPF enquanto ela faz sentido e sai do caminho no e-mail. */
export const formatIdentifier = (value) => (looksLikeDocument(value)
    ? formatCpf(value)
    : (value || '').trimStart());

/** Identificação completa o bastante para consultar, em qualquer um dos dois formatos. */
export const isCompleteIdentifier = (value) => (isEmailIdentifier(value)
    ? EMAIL_PATTERN.test((value || '').trim())
    : (value || '').replace(/\D/g, '').length === 11);

/** O valor enviado à api: e-mail sem espaços em volta, CPF só com dígitos. */
export const toIdentifierParam = (value) => (isEmailIdentifier(value)
    ? (value || '').trim()
    : (value || '').replace(/\D/g, ''));

export { EMAIL_PATTERN };
